import * as $ from 'jquery';
import { iti_config, phone_settings, safeInitIntlTelInput } from '../common/intl_tel_input_config';
import DatePicker from '../common/search_widget/date-picker';
import SingleDatePicker from '../common/search_widget/single-date-picker';
import { textFieldsInit } from './mtui/text_field';

$(function () {
  const history = [];
  let currentStep = null;

  const STEP_FIELDS = {
    '1_1_resort_choice': ['input[name="desired_resort"]', '#destination_other'],
    '1_1_1_city_choice': ['input[name="desired_city_ids[]"]', 'input[name="desired_city_recommend"]'],
    '1_2_recommendation': ['input[name="important_criteria[]"]', '#user_region'],
    '2_dates': ['input[name="travel_date_type"]', '#flexible_period', '#exact_date'],
    '2_1_month': ['input[name="desired_months[]"]'],
    '2_2_days_range': ['input[name="desired_days_range"]'],
    '2_3_guests': ['#people_count', '#children_count', 'input[name="children_ages[]"]'],
    '3_goals': ['input[name="trip_goals[]"]', '#party_special_request'],
    '3_1_treatment_direction': ['input[name="treatment_directions[]"]', '#treatment_direction_other_field'],
    '4_contacts': ['#client_name', '#client_phone'],
  };

  const partyRangeDatePicker = new DatePicker('party_form', {
    dateRange: '#flexible_period',
    dateStart: '#party_date_start',
    dateEnd: '#party_date_end',
    dateInput: '#flexible_period',
  });
  partyRangeDatePicker.init();

  const partyExactDatePicker = new SingleDatePicker('party_form', {
    dateInput: '#exact_date',
    hiddenDate: '#party_exact_date_arrival',
  });
  partyExactDatePicker.init();

  const iti = safeInitIntlTelInput('#client_phone', iti_config);

  function clearStepFields(stepId) {
    const selectors = STEP_FIELDS[stepId];
    if (!selectors) return;

    const $step = $('.party-step[data-step="' + stepId + '"]');
    selectors.forEach(function (sel) {
      $step.find(sel).each(function () {
        const $el = $(this);
        if ($el.is(':checkbox, :radio')) {
          $el.prop('checked', false);
        } else {
          $el.val('');
        }
      });
    });

    if (stepId === '2_3_guests') {
      $('#children_ages_container').empty();
    }
  }

  function clearStepsFields(stepIds) {
    stepIds.forEach(clearStepFields);
  }

  function showStep(stepId) {
    $('.party-step').addClass('hidden');
    const $step = $('.party-step[data-step="' + stepId + '"]');
    $step.removeClass('hidden');
    currentStep = stepId;
    updateStepper(stepId);
    refreshNextButtonsState($step);
    reachStepGoal($step);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  function reachStepGoal($step) {
    const goal = $step.data('metrika-goal');
    if (goal) {
      window.ymReachGoal(goal);
    }
  }

  function goToStep(stepId) {
    if (stepId === currentStep) return;
    if (currentStep !== null) history.push(currentStep);
    showStep(stepId);
  }

  function goBack() {
    const prev = history.pop();
    if (prev) {
      showStep(prev);
    } else {
      resetToStart();
    }
  }

  function resetToStart() {
    $('.party-step').addClass('hidden');
    $('#party_steps').addClass('hidden');
    if (!window.isMobileDevice) {
      $('#party_stepper').addClass('hidden');
    }
    $('#party_photo').removeClass('hidden');
    $('#party_start_content').removeClass('hidden');
    if (window.isMobileDevice) {
      $('#party_expert_block').removeClass('hidden');
    }

    resetStepper();

    currentStep = null;
  }

  function updateStepper(stepId) {
    const $step = $('.party-step[data-step="' + stepId + '"]');
    const activeNode = parseInt($step.data('stepper-node'), 10) || 0;

    resetStepper();

    $('.party-stepper__node').each(function () {
      const n = parseInt($(this).data('node'), 10);

      if (n === activeNode) {
        $(this).addClass('active');
      } else if (n < activeNode) {
        $(this).addClass('done');
      }
    });

    $('.party-stepper__line').each(function () {
      const n = parseInt($(this).data('line'), 10);
      $(this).toggleClass('active', n < activeNode);
    });
  }

  function resetStepper() {
    $('.party-stepper__node').removeClass('active done');
    $('.party-stepper__line').removeClass('active');
  }

  function setButtonDisabled($btn, disabled) {
    $btn.prop('disabled', disabled).toggleClass('button--disabled', disabled);
  }

  function updateRadioGroupButtons($scope) {
    $scope.find('.party-step__next[data-radio-group]').each(function () {
      const $btn = $(this);
      const groupName = $btn.data('radio-group');
      const $checked = $scope.find('input[name="' + groupName + '"]:checked');

      if ($checked.length && $checked.data('next_step')) {
        $btn.attr('data-next_step', $checked.data('next_step'));
        $btn.removeClass('hidden');
        setButtonDisabled($btn, false);
      } else {
        $btn.addClass('hidden');
      }
    });
  }

  function updateDatesNextButton($scope) {
    const $btn = $scope.find('.party-step__next[data-dates-next]');
    if (!$btn.length) return;

    const chosen = $scope.find('input[name="travel_date_type"]:checked').val();

    if (chosen === 'unknown') {
      $btn.attr('data-next_step', '2_1_month');
      $btn.removeClass('hidden');
      setButtonDisabled($btn, false);
    } else if (chosen === 'flexible') {
      $btn.attr('data-next_step', '2_2_days_range');
      $btn.removeClass('hidden');
      const val = $scope.find('#flexible_period').val();
      setButtonDisabled($btn, !(val && val.trim()));
    } else if (chosen === 'exact') {
      $btn.attr('data-next_step', '2_2_days_range');
      $btn.removeClass('hidden');
      const val = $scope.find('#exact_date').val();
      setButtonDisabled($btn, !(val && val.trim()));
    } else {
      $btn.addClass('hidden');
    }
  }

  function updateResortNextButton($scope) {
    const $btn = $scope.find('.party-step__next[data-resort-next]');
    if (!$btn.length) return;

    const $checked = $scope.find('input[name="desired_resort"]:checked');
    if (!$checked.length) {
      $btn.addClass('hidden');
      return;
    }

    const nextStep = $checked.data('next_step');
    if (nextStep) {
      $btn.attr('data-next_step', nextStep);
      $btn.removeClass('hidden');
      setButtonDisabled($btn, false);
    } else {
      $btn.attr('data-next_step', '2_dates');
      const val = $scope.find('#destination_other').val();
      const filled = val && val.trim();
      $btn.toggleClass('hidden', !filled);
      setButtonDisabled($btn, !filled);
    }
  }

  function refreshNextButtonsState($scope) {
    $scope.find('.party-step__next[data-requires-checked]').each(function () {
      const names = String($(this).data('requires-checked')).split(',');

      const anyChecked = names.some(function (name) {
        return $scope.find('input[name="' + name.trim() + '"]:checked').length > 0;
      });

      setButtonDisabled($(this), !anyChecked);
    });

    $scope.find('.party-step__next[data-requires-filled]').each(function () {
      const fieldId = $(this).data('requires-filled');
      const val = $scope.find('#' + fieldId).val();
      setButtonDisabled($(this), !val || !val.trim());
    });

    $scope.find('.party-step__next[data-requires-filled-any]').each(function () {
      const ids = String($(this).data('requires-filled-any')).split(',');
      const anyFilled = ids.some(function (id) {
        const val = $scope.find('#' + id.trim()).val();
        return val && val.trim();
      });
      setButtonDisabled($(this), !anyFilled);
    });

    $scope.find('.party-step__next[data-requires-checked-except-lone-other]').each(function () {
      const name = $(this).data('requires-checked-except-lone-other');
      const otherFieldId = $(this).data('other-field');
      const $checked = $scope.find('input[name="' + name + '"]:checked');

      if ($checked.length === 0) {
        setButtonDisabled($(this), true);
        return;
      }

      const onlyOtherChecked = $checked.length === 1 && String($checked.val()) === 'other';
      if (onlyOtherChecked) {
        const otherVal = $scope.find('#' + otherFieldId).val();
        setButtonDisabled($(this), !(otherVal && otherVal.trim()));
      } else {
        setButtonDisabled($(this), false);
      }
    });

    updateRadioGroupButtons($scope);
    updateDatesNextButton($scope);
    updateResortNextButton($scope);

    const $submit = $scope.find('.party-submit__btn');
    if ($submit.length) {
      const nameFilled = $scope.find('#client_name').val()?.trim();
      setButtonDisabled($submit, !(nameFilled && isPhoneValid()));
    }
  }

  function isPhoneValid() {
    if (!iti) return $('#client_phone').val().trim().length > 0;
    const $input = $('#client_phone');
    if ($input.val().trim() === '') return false;
    const expr = phone_settings[iti.getSelectedCountryData().iso2]?.validator;
    return expr ? expr.test($input.val().trim()) : iti.isValidNumber();
  }

  $(document).on('change keyup', '.party-step input', function () {
    refreshNextButtonsState($(this).closest('.party-step'));
  });

  $('#party_start_btn').on('click', function () {
    $('#party_photo').addClass('hidden');
    $('#party_start_content').addClass('hidden');
    if (window.isMobileDevice) {
      $('#party_expert_block').addClass('hidden');
    }
    $('#party_stepper').removeClass('hidden');
    $('#party_steps').removeClass('hidden');
    goToStep('1_preferences');
  });

  $(document).on('click', '.party-step__next[data-next_step]', function () {
    if ($(this).is(':disabled')) return;
    const nextStep = $(this).attr('data-next_step');
    if (nextStep) goToStep(String(nextStep));
  });

  $(document).on('click', '.party-step__back', function (e) {
    if (currentStep === null) window.history.back();
    e.preventDefault();
    goBack();
  });

  $(document).on('change', '[data-resort_group]', function () {
    const group = $(this).data('resort_group');
    if (group) {
      $('[data-resort_group]').addClass('hidden');
      $('[data-resort_group="' + group + '"]').removeClass('hidden');
    }
  });

  $(document).on('change', '[data-show_field]', function () {
    const target = $(this).data('show_field');
    const $step = $(this).closest('.party-step');
    $('[data-conditional_field="' + target + '"]').toggleClass('hidden', !$(this).is(':checked'));
    refreshNextButtonsState($step);
  });

  $(document).on('change', 'input[name="preferences_choice"]', function () {
    const chosen = $(this).val();
    if (chosen === 'know') {
      clearStepsFields(['1_2_recommendation']);
    } else if (chosen === 'recommend') {
      clearStepsFields(['1_1_resort_choice', '1_1_1_city_choice']);
    }
  });

  $(document).on('change', 'input[name="desired_resort"]', function () {
    $('#destination_other').val('');
    clearStepFields('1_1_1_city_choice');
  });

  $(document).on('change', 'input[name="travel_date_type"]', function () {
    const chosen = $(this).val();
    const $step = $(this).closest('.party-step');

    $('[data-conditional_field="date_range_field"]').addClass('hidden');
    $('[data-conditional_field="exact_date_field"]').addClass('hidden');
    $('#party_date_start, #party_date_end, #party_exact_date_arrival, #party_exact_date_departure').prop(
      'disabled',
      true
    );

    if (chosen === 'flexible') {
      $('[data-conditional_field="date_range_field"]').removeClass('hidden');
      $('#party_date_start, #party_date_end').prop('disabled', false);
      partyExactDatePicker.reset();
    } else if (chosen === 'exact') {
      $('[data-conditional_field="exact_date_field"]').removeClass('hidden');
      $('#party_exact_date_arrival, #party_exact_date_departure').prop('disabled', false);
      partyRangeDatePicker.reset();
    } else {
      partyRangeDatePicker.reset();
      partyExactDatePicker.reset();
      clearStepsFields(['2_1_month', '2_2_days_range']);
    }

    refreshNextButtonsState($step);
  });

  $(document).on('change', '#children_count', function () {
    const count = Math.max(0, parseInt($(this).val(), 10) || 0);
    const $container = $('#children_ages_container');
    const currentCount = $container.find('.child-age-field').length;
    const template = document.getElementById('child_age_template');

    if (count > currentCount) {
      for (let i = currentCount; i < count; i++) {
        const $clone = $(template.content.cloneNode(true));

        $clone.find('label').text('Возраст ' + (i + 1) + '-го ребёнка');
        $container.append($clone);
      }

      textFieldsInit();
    } else if (count < currentCount) {
      $container.find('.child-age-field').slice(count).remove();
    }
  });

  $(document).on('click', '.party-step__next[data-conditional_next="trip_goals_next"]', function () {
    if ($(this).is(':disabled')) return;

    const treatmentNext = $(this).data('treatment-next-step');
    const defaultNext = $(this).data('default-next-step');

    const hasTreatment = $('input[name="trip_goals[]"][value="treatment"]:checked').length > 0;
    goToStep(hasTreatment ? String(treatmentNext) : String(defaultNext));
  });

  $(document).on('change', 'input[name="trip_goals[]"]', function () {
    if ($(this).val() === 'treatment' && !$(this).is(':checked')) {
      clearStepFields('3_1_treatment_direction');
      $('.party-step__option-other[data-conditional_field="treatment_direction_other_field"]').addClass('hidden');
    }
  });

  $(document).on('click', '.party-submit__btn', function (e) {
    e.preventDefault();
    if ($(this).is(':disabled')) return;

    const $btn = $(this);
    $btn.prop('disabled', true);

    $.ajax({
      url: $('#party_form').attr('action'),
      method: 'POST',
      data: $('#party_form').serialize(),
      success: function (res) {
        const successText = res.working_hours
          ? 'Менеджер подготовит подборку и свяжется с вами по телефону или в мессенджере.'
          : 'Менеджер свяжется с Вами с 8.00 до 20.00 по московскому времени';
        $('#finish_info').text(successText);
        if (window.isMobileDevice) {
          $('.party__header .party-step__back').addClass('hidden');
        }
        $('#party_stepper').addClass('hidden');
        $('#steps_done').removeClass('hidden');
        $('#party_steps').addClass('hidden');
        $('#party_finish_content').removeClass('hidden');
      },
      error: function () {
        $btn.prop('disabled', false);
      },
    });
  });
});
